import LocalityPage from "../components/LocalityPage";
import { DEPTS, VILLES } from "../data/zones";

const DEPT_CONTEXT = {
    "92": {
        accroche: "de Boulogne-Billancourt à Neuilly-sur-Seine, de La Défense à Montrouge",
        villes_ex: ["Boulogne-Billancourt", "Neuilly-sur-Seine", "Courbevoie", "Levallois-Perret", "Nanterre", "Asnières-sur-Seine"],
        communes_small: ["Puteaux", "Suresnes", "Rueil-Malmaison", "Clamart", "Malakoff", "Vanves", "Châtillon", "Bagneux"],
    },
    "93": {
        accroche: "de Saint-Denis à Montreuil, de Bobigny à Aulnay-sous-Bois",
        villes_ex: ["Saint-Denis", "Montreuil", "Aubervilliers", "Bobigny", "Aulnay-sous-Bois"],
        communes_small: ["Pantin", "Noisy-le-Sec", "Drancy", "La Courneuve", "Saint-Ouen", "Les Lilas", "Romainville", "Bagnolet"],
    },
    "94": {
        accroche: "de Vincennes à Créteil, de Saint-Maur-des-Fossés à Vitry-sur-Seine",
        villes_ex: ["Vincennes", "Créteil", "Saint-Maur-des-Fossés", "Champigny-sur-Marne", "Vitry-sur-Seine"],
        communes_small: ["Maisons-Alfort", "Alfortville", "Ivry-sur-Seine", "Choisy-le-Roi", "Nogent-sur-Marne", "Joinville-le-Pont", "L'Hay-les-Roses", "Cachan"],
    },
    "77": {
        accroche: "de Melun à Meaux, de Chelles à Fontainebleau",
        villes_ex: ["Melun", "Meaux", "Chelles", "Torcy", "Combs-la-Ville"],
        communes_small: ["Dammarie-les-Lys", "Savigny-le-Temple", "Lagny-sur-Marne", "Noisiel", "Serris", "Cesson", "Vaux-le-Pénil"],
    },
    "78": {
        accroche: "de Versailles à Saint-Germain-en-Laye, de Sartrouville à Mantes-la-Jolie",
        villes_ex: ["Versailles", "Saint-Germain-en-Laye", "Maisons-Laffitte", "Sartrouville", "Poissy"],
        communes_small: ["Le Chesnay-Rocquencourt", "Chatou", "Houilles", "Conflans-Sainte-Honorine", "Achères", "Viroflay", "Buc"],
    },
    "91": {
        accroche: "d'Évry à Massy, de Corbeil-Essonnes à Palaiseau",
        villes_ex: ["Évry", "Massy", "Corbeil-Essonnes", "Palaiseau", "Antony"],
        communes_small: ["Ris-Orangis", "Bondoufle", "Courcouronnes", "Wissous", "Chilly-Mazarin", "Verrières-le-Buisson"],
    },
    "95": {
        accroche: "d'Argenteuil à Cergy, de Pontoise à Sannois",
        villes_ex: ["Argenteuil", "Cergy", "Pontoise", "Osny", "Herblay"],
        communes_small: ["Sannois", "Houilles", "Bezons", "Jouy-le-Moutier", "Saint-Ouen-l'Aumône", "Conflans-Sainte-Honorine"],
    },
};

export default function DeptPage({ dept, idf = false }) {
    if (idf) {
        return (
            <LocalityPage
                name="Île-de-France"
                cp="IDF"
                kicker="Région — 75, 77, 78, 91, 92, 93, 94, 95"
                crumb="Île-de-France"
                introTitle="Serrurier Île-de-France — Paris et toute la grande couronne"
                introP1="Porte claquée à Boulogne-Billancourt, serrure à changer à Versailles, rideau métallique bloqué à Saint-Denis ou blindage à poser à Créteil : nos artisans serruriers couvrent l'ensemble de la région Île-de-France — les 20 arrondissements de Paris et les 7 départements de grande couronne (77, 78, 91, 92, 93, 94, 95). Devis gratuit par téléphone avant chaque intervention, agréés assurance habitation, dans le métier depuis 1985."
                introP2="Nos équipes sont disponibles 24h/24, 7j/7 sur toute la région : nuits, week-ends et jours fériés. Délai d'intervention garanti en 30 minutes, aussi bien au cœur de Paris que dans les communes les plus éloignées comme Meaux (77), Fontainebleau (77), Mantes-la-Jolie (78) ou Cergy (95)."
                chips={DEPTS.map((d) => ({ label: `Serrurier ${d.name} (${d.code})`, to: `/serrurier-${d.code}` }))}
                others={[{ label: "Serrurier Paris — 20 arrondissements", to: "/zones-d-intervention" }]}
                path="/serrurier-ile-de-france"
                seoTitle="Serrurier Île-de-France — Urgence 24/7 · Intervention 30 min · Devis Gratuit"
                seoDesc="Serrurier Île-de-France : ouverture de porte 60 € TTC, changement de serrure, blindage sur toute la région (77, 78, 91, 92, 93, 94, 95). Artisan agréé assurance, 24h/24. ☎ 06 25 25 86 19"
            />
        );
    }

    const villes = VILLES.filter((v) => v.dept === dept.code);
    const ctx = DEPT_CONTEXT[dept.code] || {};
    const accroche = ctx.accroche || `dans tout le ${dept.code}`;
    const villesEx = ctx.villes_ex || villes.slice(0, 4).map((v) => v.name);
    const communesSmall = ctx.communes_small || [];

    return (
        <LocalityPage
            name={`${dept.name} (${dept.code})`}
            cp={dept.code}
            kicker={`Département — ${dept.code}`}
            crumb={`${dept.name} (${dept.code})`}
            introTitle={`Serrurier ${dept.name} (${dept.code}) — ${accroche}`}
            introP1={`Porte claquée à ${villesEx[0] || dept.name}, serrure abîmée à ${villesEx[1] || dept.name} ou blindage à renforcer à ${villesEx[2] || dept.name} ? Nos artisans serruriers couvrent l'ensemble du département ${dept.code} (${dept.name}) : ouverture de porte sans casse dès 60 € TTC, changement de cylindre certifié A2P, blindage de porte, double de clé. Devis gratuit communiqué par téléphone avant chaque intervention — agréés assurance habitation, dans le métier depuis 1985.`}
            introP2={`Nous intervenons dans toutes les communes du ${dept.code} : ${villesEx.join(", ")}${communesSmall.length ? `, ainsi que ${communesSmall.slice(0, 5).join(", ")} et les communes environnantes` : ""}. Service disponible 24h/24, 7j/7 — nuits, week-ends et jours fériés compris — avec un délai d'intervention garanti en 30 minutes dans tout le département.`}
            chips={villes.map((v) => ({ label: `Serrurier ${v.name}`, to: `/serrurier-${v.slug}` }))}
            others={DEPTS.filter((d) => d.code !== dept.code).map((d) => ({
                label: `Serrurier ${d.name} (${d.code})`,
                to: `/serrurier-${d.code}`,
            }))}
            path={`/serrurier-${dept.code}`}
            seoTitle={`Serrurier ${dept.name} (${dept.code}) — Urgence 24/7 · Intervention 30 min · Devis Gratuit`}
            seoDesc={`Serrurier ${dept.name} (${dept.code}) : ouverture de porte 60 € TTC, changement de serrure, blindage. Artisan agréé assurance, chez vous en 30 min dans tout le ${dept.code}, 24h/24. ☎ 06 25 25 86 19`}
        />
    );
}
